/* eslint-disable react/prop-types */
import { Grid, Card } from "@material-ui/core";

const OverViewCard = ({ cardDetails }) => {
	return (
		<Grid container className="card-container-grid">
			{cardDetails.map((eachCard, index) => (
				<Grid item xs={3} sm={3} md={3} lg={3} xl={3} key={index} className="each-card-container">
					<div className={`display-card-container +  ${eachCard.className}`}>
						<div className="each-icon-container">
							{eachCard.icon()}
							{/* <div className="icon-container">{eachCard.icon()}</div> */}
						</div>
						<div className="amount-container">{eachCard.amount}</div>
						<div className="title-container">{eachCard.title}</div>
					</div>
				</Grid>
			))}
		</Grid>
	);
};

export default OverViewCard;
